// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"08319e63","161":"232f6608","209":"e1f55257","478":"a5304c1a","562":"879bd2b5","625":"539cf7dc","675":"b1f76407","745":"4cdb9fc4","861":"0dc07533","922":"9c7b09da","964":"e9075ea5"}[chunkId] + ".chunk.js";
};